export enum ButtonSize {
  Large = 'large',
  Medium = 'medium',
  Small = 'small',
  /**
   * 하단고정형 버튼은 높이가 다릅니다. 직접 주입해주어도 상관은 없지만, 디자인팀에서 관리하고 있는 항목이라서
   * Button에서 관리하는 게 유리할 것 같아 size로 추가했습니다.
   * https://www.figma.com/file/lun1D9CzpkoufkINaOHID1/NEXT_Design_System?node-id=3413%3A22325
   */
  BottomFixed = 'bottomfixed',
}

export enum ButtonColorScheme {
  '1st' = '1st',
  '2nd' = '2nd',
  '3rd' = '3rd',
  '4st' = '4st',
  sp = 'sp',
  sp_2nd = 'sp_2nd',
  Text = 'text',
  Disable = 'disable',
}
